import React from 'react';
import { OriginVisual } from './OriginVisual';

export const OriginLeftImage = ({ origin, originExceptionFlag }) => {
  return (
    <OriginVisual origin={origin} lower="left" originExceptionFlag={originExceptionFlag} />
  );
};